import { TreeNode } from "@/shared/interfaces";
import { IconButton, Typography } from "@mui/material";
import {
  TreeItem,
} from '@mui/x-tree-view/TreeItem';
import { Add, Delete, Edit, } from '@mui/icons-material';
import "../plan-cuenta-page.css";

export default function RenderTreeComponente(
  nodes: TreeNode,
  addNode: (id: string) => void,
  deleteNode: (id: string) => void,
  editNode: (id: string, name: string) => void,
  setEditNodeId: (id: string | null) => void,
  editNodeId: string | null,
  editNodeName: string,
  setEditNodeName: (name: string) => void) {
  return (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={(
        <div className={`node-container`}>
          <div className="node-content">
            <Typography variant='subtitle1'>{`${nodes.id} ${nodes.name}`}</Typography>
            <div className="file-actions">
              <div className="folderFileActions">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    editNode(nodes.id, nodes.name)
                    //setEditNodeId(nodes.id);
                    //setEditNodeName(nodes.name);
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();

                    addNode(nodes.id);
                  }}
                >
                  <Add fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteNode(nodes.id);
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </div>
            </div>

          </div>
        </div>
      )}
    >
      {
        Array.isArray(nodes.children)
          ? nodes.children.map((node) => RenderTreeComponente(
            node,
            addNode,
            deleteNode,
            editNode,
            setEditNodeId,
            editNodeId,
            editNodeName,
            setEditNodeName,
          )
          )
          : null
      }
    </TreeItem >
  );
}